import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const LineReveal = ({ lines, className = "", delay = 0, as: Tag = "h1", testId }) => (
  <Tag className={className} data-testid={testId}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.2, ease: EASE, delay: delay + i * 0.13 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.28em] ${light ? "text-[#F7EFD2]" : "text-[#0D9488]"}`}>
    <span className="h-px w-8 bg-[#D4AF37]" />
    {children}
  </p>
);
